import loadable from '@loadable/component'

const LoadableStyledFirebaseAuth = loadable(() =>
  import('./StyledFirebaseAuthWrapper'),
)

export default LoadableStyledFirebaseAuth
